export default function Footer() {
  return (
    <footer className="home-footer">
      <p>
        © {new Date().getFullYear()} Boolforge. Built for learning digital
        logic.
      </p>
    </footer>
  );
}
